module.exports = __webpack_public_path__ + "media/images/ic-index-text-4a006d4bbbaee3d39a830f092b20da65.svg";